// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pWSzXYNa{align-items:center;background:#000;display:flex;justify-content:space-between;padding:0 10px 0 22px;width:100%}.ok-Sr5hS{overflow:hidden;padding-right:2em}.vv1pecp5{color:#b1ec52;font-size:.9rem;margin-bottom:.2rem;white-space:nowrap}.qzsIr68v{color:#fff;font-size:.8rem;margin:0;white-space:nowrap}.vv1pecp5,.qzsIr68v{overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reply": "pWSzXYNa",
	"replyLeft": "ok-Sr5hS",
	"replyName": "vv1pecp5",
	"replyText": "qzsIr68v"
};
module.exports = ___CSS_LOADER_EXPORT___;
